/**
 * Calculate asset deviation from recommended allocation.
 * @param {Object} params
 * @param {number|null} params.actual - actual % within group (raw decimal, e.g. 0.13)
 * @param {number|null} params.recommended - recommended % (alocacao_especifica or alocacao_global, raw decimal)
 * @param {number|null} params.margin - margem_suitability_ativos (raw decimal, e.g. 0.25 for 25%)
 * @returns {{ deviation: number|null, isOutOfMargin: boolean }}
 */
export function calcularDesvioAtivo({ actual, recommended, margin }) {
  if (margin == null || margin === 0) {
    return { deviation: null, isOutOfMargin: false }
  }
  if (recommended == null || recommended === 0) {
    return { deviation: null, isOutOfMargin: false }
  }
  if (actual == null) {
    return { deviation: null, isOutOfMargin: false }
  }
  const deviation = Math.abs(actual - recommended) / recommended
  return { deviation, isOutOfMargin: deviation > margin }
}
